import { getEnvParameter } from '@/api/settings/request'
import store from '@/store'
import { ENGINEER_HOST_NAME, EmailTypes } from '@/utils/consts'
import dateUtil from '@/utils/dateUtil'
import { SEND_EMAIL, SEND_TO_ENGINEER, SEND_TO_VENDOR } from './consts'
import { buildProjectInfo, getMetaData, getProjectRepEmails } from './project.utils'
import { buildEmail, getLink, getPublicLink, getSiteInfo, getVendorHomeLink } from './util'

const projectNotification = {
  notifyInvitation: async (emailType) => {
    const emails = []
    const [project, vendorDetail, subAccountEmails] = await getMetaData()
    const projectInfo = buildProjectInfo(project)
    const projectLink = getVendorHomeLink()
    const siteInfo = await getSiteInfo(projectInfo.site)
    const metadata = {
      cc: subAccountEmails,
      projectInfo,
      siteInfo,
      projectLink,
      vendorDetail,
    }
    buildEmail(emails, vendorDetail.email, emailType, metadata, SEND_TO_VENDOR)
    return emails
  },

  notifySubmissionAcceptance: async (emailType, metaData = {}) => {
    const emails = []
    const [project, vendorDetail, subAccountEmails] = await getMetaData()
    const projectInfo = buildProjectInfo(project)
    projectInfo.submissionOrder = metaData.order || 1
    projectInfo.action = metaData.action
    projectInfo.showNote = metaData.showNote
    projectInfo.unacceptedComment = metaData.unacceptedComment
    const projectLink = getVendorHomeLink()
    const metadata = {
      cc: subAccountEmails,
      projectInfo,
      projectLink,
      vendorDetail,
    }
    buildEmail(emails, vendorDetail.email, emailType, metadata, SEND_TO_VENDOR)
    return emails
  },

  notifyCompletionSubmission: async (emailType, metaData = {}) => {
    const emails = []
    const [project, vendorDetail] = await getMetaData()
    const projectInfo = buildProjectInfo(project)
    projectInfo.submissionOrder = metaData.order || 1
    const submission = project.submissions[metaData.index]
    projectInfo.submissionDescription = submission.completedItems
    const projectLink = getLink('projectDetail', project.id, ENGINEER_HOST_NAME)
    const metadata = { projectInfo, projectLink, vendorDetail }
    const projectRepEmails = await getProjectRepEmails(project.id)
    metadata.cc = projectRepEmails
    buildEmail(emails, projectInfo.pic.email, emailType, metadata, SEND_TO_ENGINEER)
    return emails
  },
  invitePrimaryContact: async (extMetaData) => {
    const emails = []
    const project = store.getters['projects/currentProject']
    const purchase = store.getters['projects/purchase']
    const siteInfo = await getSiteInfo(purchase.siteId)
    extMetaData.linkToAccess = getPublicLink('vendorProjectDetail', project.id)
    extMetaData.subsidiary = siteInfo.subsidiary
    extMetaData.needResetPwdLink = true
    extMetaData.project = project
    extMetaData.purchase = purchase
    extMetaData.siteCode = siteInfo.note || siteInfo.code
    extMetaData.isHKLProject = true
    const passwordExpiresIn = await getEnvParameter('token.passwordExpiresIn')
    extMetaData.passwordExpiresIn = dateUtil.transTimeUnitByLang(passwordExpiresIn)
    buildEmail(emails, extMetaData.to, EmailTypes.projects.invitePrimaryContact, extMetaData, SEND_EMAIL)
    return emails
  },
}

export default projectNotification
